import { render, staticRenderFns } from "./Partners.vue?vue&type=template&id=617b3907&scoped=true"
import script from "./Partners.vue?vue&type=script&lang=js"
export * from "./Partners.vue?vue&type=script&lang=js"
import style0 from "./Partners.vue?vue&type=style&index=0&id=617b3907&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617b3907",
  null
  
)

export default component.exports